// Interface

import util from '@/utils/classToObject'
import { IUiState } from './state'

export class UiGetter {
     
    public contentHeight(state: IUiState){
        return state.contentHeight
    }

    public rightDrawerOpen(state: IUiState){
        return state.rightDrawerOpen
    }     

    public rightDrawerEnable(state: IUiState){
        return state.rightDrawerEnable
    }  
    
    public drawerOpen(state: IUiState){
        return state.drawerOpen
    }  

    public drawerEnable(state: IUiState){
        return state.drawerEnable
    } 
    
    public snackMessages(state: IUiState) {
        return state.snackMessages
    }          

    public showCart(state: IUiState) {
        return state.showCart
    }         

    public searchUser(state: IUiState) {
        return state.searchUser
    } 

    public sortUserDesc(state: IUiState) {
        return state.sortUserDesc
    }   

    public sortUserBy(state: IUiState) {
        return state.sortUserBy
    }     

    public searchMailTemplate(state: IUiState) {
        return state.searchMailTemplate
    } 

    public sortMailTemplateDesc(state: IUiState) {
        return state.sortMailTemplateDesc
    }   

    public sortMailTemplateBy(state: IUiState) {
        return state.sortMailTemplateBy
    } 

    public searchMailSkin(state: IUiState) {
        return state.searchMailSkin
    } 

    public sortMailSkinDesc(state: IUiState) {
        return state.sortMailSkinDesc
    }   

    public sortMailSkinBy(state: IUiState) {
        return state.sortMailSkinBy
    }  

    public searchPiscine(state: IUiState) {
        return state.searchPiscine
    } 

    public sortPiscineDesc(state: IUiState) {
        return state.sortPiscineDesc
    }   

    public sortPiscineBy(state: IUiState) {
        return state.sortPiscineBy
    }  
    
    public monthPiscine(state: IUiState){
        return state.monthPiscine?new Date(state.monthPiscine):new Date()
    }

    public searchActivity(state: IUiState) {
        return state.searchActivity
    } 

    public sortActivityDesc(state: IUiState) {
        return state.sortActivityDesc
    }   

    public sortActivityBy(state: IUiState) {
        return state.sortActivityBy
    }  

    public searchForfait(state: IUiState) {
        return state.searchForfait
    } 

    public sortForfaitDesc(state: IUiState) {
        return state.sortForfaitDesc
    }   

    public sortForfaitBy(state: IUiState) {
        return state.sortForfaitBy
    }  

    public searchMns(state: IUiState) {
        return state.searchMns
    } 

    public sortMnsDesc(state: IUiState) {
        return state.sortMnsDesc
    }   

    public sortMnsBy(state: IUiState) {
        return state.sortMnsBy
    }  
    
    public searchContact(state: IUiState) {
        return state.searchContact
    } 

    public sortContactDesc(state: IUiState) {
        return state.sortContactDesc
    }   

    public sortContactBy(state: IUiState) {
        return state.sortContactBy
    }

    public monthContact(state: IUiState){
        return state.monthContact?new Date(state.monthContact):new Date()
    }

    public searchNewsletter(state: IUiState) {
        return state.searchNewsletter
    } 

    public sortNewsletterDesc(state: IUiState) {
        return state.sortNewsletterDesc
    }   

    public sortNewsletterBy(state: IUiState) {
        return state.sortNewsletterBy
    }  

    public searchCours(state: IUiState) {
        return state.searchCours
    } 

    public sortCoursDesc(state: IUiState) {
        return state.sortCoursDesc
    }   

    public sortCoursBy(state: IUiState) {
        return state.sortCoursBy
    }  


    public searchCommande(state: IUiState) {
        return state.searchCommande
    } 

    public sortCommandeDesc(state: IUiState) {
        return state.sortCommandeDesc
    }   

    public sortCommandeBy(state: IUiState) {
        return state.sortCommandeBy
    }  

    public monthCommande(state: IUiState){
        return state.monthCommande?new Date(state.monthCommande):new Date()
    }

    public searchFamily(state: IUiState) {
        return state.searchFamily
    } 

    public sortFamilyDesc(state: IUiState) {
        return state.sortFamilyDesc
    }   

    public sortFamilyBy(state: IUiState) {
        return state.sortFamilyBy
    } 
        
}

export default util.classToObject(UiGetter)